import { render, staticRenderFns } from "./UsersComp.vue?vue&type=template&id=d85712a8&scoped=true&"
import script from "./UsersComp.vue?vue&type=script&lang=js&"
export * from "./UsersComp.vue?vue&type=script&lang=js&"
import style0 from "../../assets/scss/usersADC.scss?vue&type=style&index=0&id=d85712a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d85712a8",
  null
  
)

export default component.exports